import { render } from "./main.vue?vue&type=template&id=3a814d37"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import exportComponent from "D:\\EZENMS_VUE\\eze-nms-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__